<template>
    <base-dropdown v-if="showOtherCards" :styles="dropdownStyle">
        <template #dropdown-content>
            <div class="other-cards-wrapper">
                <p
                    v-for="(card, indx) in otherCards"
                    :key="indx"
                    @click="selectCard(card.id)"
                    class="card"
                >
                    {{ `${card.brand} *${card.last_four}` }}
                </p>
            </div>
        </template>
    </base-dropdown>
</template>
<script>
    import BaseDropdown from '@/components/ui/dropdowns/BaseDropdown'
    import { usePaymentMethods } from '@/composables/features/payments-methods/usePayments'
    export default {
        name: 'OtherCardsDropdown',
        components: {
            BaseDropdown
        },
        props: {
            showOtherCards: {
                required: true,
                type: Boolean
            },
            otherCards: {
                required: false,
                type: Array,
                default: () => []
            }
        },
        setup() {
            const { selectCard } = usePaymentMethods()

            return {
                selectCard
            }
        },
        data: () => ({
            dropdownStyle: {
                width: '100%',
                'max-height': '200px'
            }
        })
    }
</script>
<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }
    .other-cards-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;
        max-height: 150px;
        max-width: 380px;
        width: 100%;

        .card {
            color: #8b8b8b;
            font-family: 'Instrument Sans';
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
            font-size: 14px;
            background: none;
            border: none;
            width: 100%;
            cursor: pointer;
        }

        .card:hover {
            color: #dedede;
        }
    }
</style>
